import React from 'react';
import MainChat from './components/layout/MainChat';
import { useConversations } from './hooks/useConversations';
import './App.css';

function App() {
  const {
    currentMessages,
    isLoading,
    handleSendMessage,
    projectData,
    currentSceneIndex,
    setCurrentSceneIndex,
    sceneGenerationStatus,
    isGeneratingScene,
    generateScene,
    approveScene,
    refineScene,
    finalizeProject,
    createProjectWithScenes,
    handleNewChat,
    resetKey,
  } = useConversations();

  return (
    <div className="w-full h-screen flex bg-gray-50">
      <MainChat
        messages={currentMessages}
        isLoading={isLoading}
        onSendMessage={handleSendMessage}
        projectData={projectData}
        currentSceneIndex={currentSceneIndex}
        setCurrentSceneIndex={setCurrentSceneIndex}
        sceneGenerationStatus={sceneGenerationStatus}
        isGeneratingScene={isGeneratingScene}
        onGenerateScene={generateScene}
        onApproveScene={approveScene}
        onRefineScene={refineScene}
        onFinalizeProject={finalizeProject}
        onCreateProject={createProjectWithScenes}
        onNewChat={handleNewChat}
        resetKey={resetKey}
      />
    </div>
  );
}

export default App;
